export const IMAGES = {
  heroResidential:
    "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwd2hpdGUlMjBjYXJwZXR8ZW58MHx8fHwxNzgzMzA4NzEwfDA&ixlib=rb-4.1.0&q=85",
  commercial:
    "https://images.unsplash.com/photo-1676474987690-2fc0582a07ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBtb2Rlcm4lMjBjYXJwZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODMzMDg3MTB8MA&ixlib=rb-4.1.0&q=85",
  kelowna:
    "https://images.unsplash.com/photo-1542509429033-7af0f116a270?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxrZWxvd25hJTIwbW91bnRhaW5zJTIwbGFrZXxlbnwwfHx8fDE3ODMzMDg3MTB8MA&ixlib=rb-4.1.0&q=85",
  action:
    "https://images.unsplash.com/photo-1742483359033-13315b247c74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxjYXJwZXQlMjBjbGVhbmluZyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODMzMDg3MzR8MA&ixlib=rb-4.1.0&q=85",
  water:
    "https://images.unsplash.com/photo-1498462440456-0dba182e775b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxzcGFya2xpbmclMjBjbGVhbiUyMHdhdGVyJTIwc3BsYXNofGVufDB8fHx8MTc4MzMwODczNHww&ixlib=rb-4.1.0&q=85",
  upholstery:
    "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHx1cGhvbHN0ZXJ5JTIwc29mYSUyMGNsZWFuaW5nfGVufDB8fHx8MTc4MzMwOTA3NXww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "residential",
    name: "Residential Carpet Cleaning",
    icon: "Home",
    blurb:
      "Deep steam extraction for living rooms, bedrooms, stairs and hallways — leaving fibres fresh, soft and fast-drying.",
    img: IMAGES.heroResidential,
  },
  {
    id: "commercial",
    name: "Commercial Cleaning",
    icon: "Building2",
    blurb:
      "Offices, retail, and strata common areas cleaned on your schedule with minimal disruption to your business.",
    img: IMAGES.commercial,
  },
  {
    id: "moveout",
    name: "Move-Out Cleaning",
    icon: "Truck",
    blurb:
      "End-of-tenancy carpet cleaning that helps you pass inspections and get your deposit back. Landlords welcome.",
    img: IMAGES.action,
  },
  {
    id: "upholstery",
    name: "Upholstery & Furniture",
    icon: "Sofa",
    blurb:
      "Sofas, sectionals, dining chairs and mattresses — gentle, fabric-safe cleaning that lifts stains and odours.",
    img: IMAGES.upholstery,
  },
  {
    id: "patio",
    name: "Patio Furniture",
    icon: "Armchair",
    blurb:
      "Outdoor cushions and patio sets restored for the Okanagan summer — mildew, pollen and grime removed.",
    icon2: true,
    img: IMAGES.water,
  },
  {
    id: "rugs",
    name: "Area Rugs",
    icon: "Layers",
    blurb:
      "Wool, synthetic and delicate specialty rugs cleaned with the right method for the fibre — no guesswork.",
    img: IMAGES.commercial,
  },
  {
    id: "tile",
    name: "Tile & Grout",
    icon: "Grid3x3",
    blurb:
      "High-pressure tile and grout restoration that brings back the original colour of your floors.",
    img: IMAGES.action,
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.name);

export const CONTACT = {
  phone: "(778) 581-7951",
  phoneHref: "tel:+17785817951",
  email: "kelownacleancarpets@gmail.com",
  area: "Kelowna, West Kelowna, Lake Country & Peachland, BC",
  hours: "Open 24/7 — Day or Night, We're Here to Help",
};
